import React, { useState } from "react";
import axios from "axios";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useAddDealerMutation } from "../../features/api/dealerApi";
// import { useAddDealerMutation } from "../../../features/api/dealerApi";

const NewDealer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [addNewDealer] = useAddDealerMutation();

  const [d_name, setName] = useState("");
  const [d_email, setEmail] = useState("");
  const [d_address, setAddress] = useState("");
  const [d_phone, setPhone] = useState("");
  const [d_mobile, setMobile] = useState("");
  const [d_web, setWeb] = useState("");
  const handleAdd = async () => {
    try {
      const newDealer = {
        d_name,
        d_email,
        d_address,
        d_phone,
        d_mobile,
        d_web,
      };
      const result = await addNewDealer(newDealer);

      if (result) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Dealer create success...!!!");

        setName("");
        setEmail("");
        setAddress("");
        setPhone("");
        setMobile("");
        setWeb("");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className="text-white bg-blue-500 flex items-center rounded px-2 py-1 cursor-pointer"
      >
        <MdAdd className="text-2xl  font-bold " /> New Client
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[600px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Add New Dealer</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      value={d_name}
                      onChange={(e) => setName(e.target.value)}
                      className="border pl-1"
                      placeholder="Name"
                    />
                    <input
                      type="email"
                      value={d_email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="border pl-1"
                      placeholder="Email"
                    />
                    <input
                      type="text"
                      value={d_address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="border pl-1"
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      value={d_phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="border pl-1"
                      placeholder="Phone"
                    />
                    <input
                      type="text"
                      value={d_mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="border pl-1"
                      placeholder="Mobile"
                    />
                    <input
                      type="text"
                      value={d_web}
                      onChange={(e) => setWeb(e.target.value)}
                      className="border pl-1"
                      placeholder="Website"
                    />
                  </div>
                  <button
                    onClick={() => handleAdd()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewDealer;


// orderss= [
  
//   {
//       "id": 245,
//       "inv_no": "IV-7/23",
//       "inv_date": "2023-09-10T18:00:00.000Z",
//       "d_date": "2023-09-29T18:00:00.000Z",
//       "sub_cat": 61,
//       "pro_name": 102,
//       "qty": 1,
//       "u_name": 13,
//       "sales_rate": 2000,
//       "total": 2000,
//   },
//   {
//       "id": 246,
//       "inv_no": "IV-7/23",
//       "inv_date": "2023-09-10T18:00:00.000Z",
//       "d_date": "2023-09-29T18:00:00.000Z",
//       "sub_cat": 61,
//       "pro_name": 103,
//       "qty": 1,
//       "u_name": 13,
//       "sales_rate": 1800,
//       "total": 1800,
//   }
// ]
// This array data fetch from CiDatabase, now If I want to insert into another table of database then how insert only if I insert first data I mean "id": 245. then how to remove second data and insert only first data. I used react. Please give me code with example using react.